import React from "react";
import loadingImage from '../../../../../assets/img/icons/loading.svg';
import { Progress } from "antd";
import { useViewerStore } from "../../../../../store/store";
import { EnggAction } from "../../../../../@types/enums";

interface EngineeringLoaderProps { action: EnggAction }

const EngineeringLoader: React.FC<EngineeringLoaderProps> = ({ action }) => {

  const { engDownloadProgress } = useViewerStore();

  return (
    <div className="tab_loader">
      {action === EnggAction.Download ? <Progress percent={engDownloadProgress} /> : <img src={loadingImage} />}
      
      {<p className={"theme-based-text-color"}>
        {(action === EnggAction.Refresh || action === EnggAction.Reset)
          ? `${action === EnggAction.Refresh ? 'Updating' : 'Resetting'} the data. `
          : `${engDownloadProgress === 0 ? 'Preparing' : 'Downloading'} the file. `}
        Please Wait...
      </p>}
    </div>
  );
};

export default EngineeringLoader;
